import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, OFFER_ANCHOR } from '../data/fono';
export function FinalCTA() {
  return <section className="border-t-8 border-mustard bg-teal px-3 py-6 text-center sm:py-8" data-id="element-51" data-mp="3udyiftp8erlo">
      <div className="mx-auto max-w-3xl" data-id="element-52" data-mp="c7k8e5u331sk">
        <p className="text-[9px] font-extrabold uppercase tracking-[0.2em] text-mustard sm:text-xs" data-id="element-53" data-mp="856zj8k1inrk">
          One last question
        </p>

        <p className="mx-auto mt-1.5 max-w-2xl text-[13px] font-medium leading-snug text-mint sm:text-base" data-id="element-54" data-mp="m3wyktqf6xik">
          How many times have you known exactly what you wanted to work on...{' '}
          <em className="font-bold not-italic text-white" data-id="element-55" data-mp="vv1fhyznosg1">
            but still had to spend time finding or creating the material to actually do it?
          </em>{' '}
          You can keep rebuilding cards, searching through scattered files and creating
          activities from scratch. Or you can open one organized visual activity system.
          Choose the area. Find the activity. Print it. Use it.
        </p>

        <h2 className="mt-3 text-xl leading-tight text-white sm:text-3xl" data-id="element-56" data-mp="2c67rwocwdk8i">
          🗣️ FONO KIDS PRO™
        </h2>
        <p className="mt-1 text-[11px] font-extrabold uppercase tracking-wide text-mint sm:text-sm" data-id="element-57" data-mp="2h5u4cvkwiwg9">
          The complete ready-to-use activity system for pediatric speech-language
          professionals
        </p>
        <p className="mt-0.5 text-[10px] font-bold uppercase tracking-wide text-mustard" data-id="element-58" data-mp="2v3ipm4ivs5lu">
          Speech • Language • Vocabulary • Phonological Awareness • Auditory Skills •
          Narrative
        </p>

        <a href={OFFER_ANCHOR} className="mt-2.5 block" data-id="element-59" data-mp="34tlscwft0xxd">
          <img src={BOX_IMAGE} alt="FONO KIDS PRO™ complete system" className="mx-auto w-full max-w-[190px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-60" data-mp="34u3wef8pkgfu" />
        </a>

        <p className="mt-2 text-[13px] font-extrabold uppercase tracking-wide text-white" data-id="element-61" data-mp="3islg81vht8sh">
          🔥 Get the complete system today
        </p>

        <CTAButton className="mx-auto mt-2 max-w-md" data-id="element-62" data-mp="1jov6c8xq34kt">
          🗣️ YES! I WANT FONO KIDS PRO™
        </CTAButton>

        <p className="mt-1.5 text-[11px] font-bold text-mint" data-id="element-63" data-mp="1en5rsjbak8rz">
          Immediate Access • Digital Delivery 🛡️ 30-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}